const rooster = {
  previewButtonText: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-21px',
    top: '-78px',
  },
  previewButtonEmail: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-21px',
    top: '38px',
  },
  img: {
    height: '90%',
    width: '90%'
  }
}

const tops = {
  previewButtonText: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-21px',
    top: '-78px',
  },
  previewButtonEmail: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-21px',
    top: '38px',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ? tops : rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/PreviewButton.js